import { useState } from "react";
import { DashboardHeader } from "../dashboardHeader/dashboardHeader";
import { ConsumerAccountSummary } from "../consumerAccountSummary/consumerAccountSummary";
import { KeyMetricsScorecard } from "../keyMetricsScorecard/keyMetricsScorecard";
import { PaymentPerformance } from "../paymentPerformance/paymentPerformance";
import { ServiceRequestSummary } from "../serviceRequestSummary/serviceRequestSummary";
import { ComplaintSummary } from "../complaintSummary/complaintSummary";
import { DisconnectionSummary } from "../disconnectionSummary/disconnectionSummary";
import { HorizontalActionCenter } from "../horizontalActionCenter/horizontalActionCenter";
import { DashboardVisualizations } from "../dashboardVisualizations/dashboardVisualizations";
import { DashboardFooter } from "../dashboardFooter/dashboardFooter";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@shared/ui/tabs";
import { usePageViewTimer } from "@shared/hooks/usePageViewTimer";
import { QuickActionItem, QuickActions } from "@shared/components/QuickActions";
import { AlertTriangle, ArrowRightToLine, PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useGetDashboardData } from "@shared/api/hooks";
const Dashboard = () => {
  const [timeRange, setTimeRange] = useState<
    "day" | "week" | "month" | "quarter" | "year"
  >("month");
  const [userRole, setUserRole] = useState<
    "manager" | "executive" | "callcenter" | "recovery"
  >("manager");
  const navigate = useNavigate();
  usePageViewTimer({ pageName: "CX Dashboard" });
  const {data: cxDashboard} = useGetDashboardData('command_center_dashboard');
  const horizontalActions: QuickActionItem[] = [
    {
      title: "New Service Request",
      description: "Create a new service order",
      icon: PlusCircle,
      color:
        "bg-blue-50 hover:bg-blue-100 text-blue-800 border border-blue-200",
      onClick: () => navigate("/cx/services/create#customer-info"),
    },
    {
      title: "Record Payment",
      description: "Log consumer payment",
      icon: PlusCircle,
      color:
        "bg-green-50 hover:bg-green-100 text-green-800 border border-green-200",
      onClick: () => navigate("/cx/payments/create"),
    },
    {
      title: "Register Complaint",
      description: "Consumer issue logging",
      icon: PlusCircle,
      color:
        "bg-amber-50 hover:bg-amber-100 text-amber-800 border border-amber-200",
      onClick: () => navigate("/cx/complaints/create"),
    },
    {
      title: "Add Consumer",
      description: "Register a new consumer",
      icon: PlusCircle,
      color:
        "bg-purple-50 hover:bg-purple-100 text-purple-800 border border-purple-200",
      onClick: () => navigate("/cx/consumer-management/create"),
    },
    {
      title: "Raise Transfer",
      description: "Consumer transfer request",
      icon: ArrowRightToLine,
      color:
        "bg-cyan-50 hover:bg-cyan-100 text-cyan-800 border border-cyan-200",
      onClick: () => navigate("/cx/transfer/create"),
    },
    {
      title: "Disconnection",
      description: "Disconnect existing service",
      icon: AlertTriangle,
      color: "bg-red-50 hover:bg-red-100 text-red-800 border border-red-200",
      onClick: () => navigate("/cx/disconnections/create"),
    },
  ];

  return (
    <div className="space-y-6">
      <DashboardHeader timeRange={timeRange} onTimeRangeChange={setTimeRange} />

      {/* Analytics & Insights Section - Now at the top as a horizontal card */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
        <div className="col-span-1 md:col-span-3">
          <DashboardVisualizations
            timeRange={timeRange}
            userRole={userRole}
            section="horizontal"
            consumerSummary={cxDashboard?.metrics?.consumerSummaryCard}
            revenueTrendData={cxDashboard?.metrics?.revenueTrend}
            serviceTrendData={cxDashboard?.metrics?.serviceTrend}
            consumptionUsageData={cxDashboard?.metrics?.consumptionUsage}
          />
        </div>
      </div>

      {/* Main Dashboard Grid */}
    <div className="grid grid-cols-1 md:grid-cols-12 gap-5 mb-5">
  {/* First row - 2 cards */}
  <div className="col-span-1 md:col-span-6">
    <div className="h-full">
      {/* <KeyMetricsScorecard outstandingData={cxDashboard?.metrics?.outstandingSummary}/> */}
    </div>
  </div>
  <div className="col-span-1 md:col-span-6">
    <div className="h-full">
      {/* <PaymentPerformance outstandingData={cxDashboard?.metrics?.outstandingSummary} /> */}
    </div>
  </div>

  {/* Second row - 3 cards */}
  <div className="col-span-1 md:col-span-4">
    <div className="h-full">
      <ServiceRequestSummary supportData={cxDashboard?.metrics?.monthlySupportSummary} />
    </div>
  </div>
  <div className="col-span-1 md:col-span-4">
    <div className="h-full">
      <ComplaintSummary supportData={cxDashboard?.metrics?.monthlySupportSummary} />
    </div>
  </div>
  <div className="col-span-1 md:col-span-4">
    <div className="h-full">
      <DisconnectionSummary supportData={cxDashboard?.metrics?.monthlySupportSummary} />
    </div>
  </div>
</div>


      {/* Horizontal Quick Actions */}
      <div className="mb-5">
        {/* <HorizontalActionCenter timeRange={timeRange} userRole={userRole} /> */}
        <QuickActions actions={horizontalActions} />
      </div>

      {/* Footer spans full width */}
      <div className="col-span-12">
        <DashboardFooter />
      </div>

      {/* Role-specific dashboard tabs with improved spacing */}
    </div>
  );
};
export default Dashboard;
